export class CustomerTokensService {
	constructor(CoreApi) {
		this.CoreApi = CoreApi;
	}
	get(id) {
		return this.CoreApi.makeApiCall("POST", "tokens/get", {customer: id}).then(r => r.data);
	}
	createCallcenterToken(id) {
		return this.CoreApi.makeApiCall("POST", "tokens/create/", {customer: id, tokens: ["callcenter"]}).then(r => r.data);
	}
	createRecordingsToken(id) {
		return this.CoreApi.makeApiCall("POST", "tokens/create/", {customer: id, tokens: ["recordings"]}).then(r => r.data);
	}
}
